<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-contact-phone</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.contact') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;" />
      <v-switch
        :value="content.HideDivider"
        :label="$t('contact.hideDivider')"
        :color="enterpriseColor"
        hide-details
        style="margin-top: 0px;float: right; margin-right: 10px;"
        @change="handleChangeHideDivider"
      />
    </v-toolbar>
    <v-btn
      v-show="!collapseContent"
      dark
      block
      @click="handleAddItem"
      :color="enterpriseColor"
    >
      <v-icon>mdi-plus</v-icon>{{ $t('contact.addItem') }}
    </v-btn>
    <contact-item
      v-show="!collapseContent"
      v-for="(item, index) in content.ContactItems"
      :key="`contactItem${index}`"
      :data="item"
      :onDelete="handleDelete"
      :id="`contactItem${index}`"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import _ from 'lodash'
  import ContactItem from './ContactItem'
  export default {
    components: {
      ContactItem,
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      modalDate: false
    }),
    computed: {
      ...mapState('app',['locale','collapseContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    methods: {
      handleDelete (id) {
        this.content.ContactItems = this.content.ContactItems.filter(x => x.ID !== id)
      },
      handleAddItem () {
        this.handleChangeIsModified()
        this.content.ContactItems.push({
          ID: `new_${_.uniqueId()}`,
          ContactIcon: 2,
          ContactDescription: { es: ''},
          ContactURL: { es: ''},
        })
      },
      handleChangeHideDivider () {
        this.content.HideDivider = !this.content.HideDivider
        this.$store.state.app.isModified = true
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>
